import React from "react";
import PropTypes from "prop-types";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { Row, Col } from "react-bootstrap";

import DropdownSearch, {
  DropdownSearchSelect
} from "../../../common/DropdownSearch";

import ReportFilters from "../../ReportFiltersComponent";

const Filters = ({
  filters,
  onChangeFilters,
  onReset,
  contracts,
  filterError,
  onFilter,
  multiple,
  loading,
  exportDisabled,
  onPDFExport,
  isReport,
  title
}) => {
  const activeTitle = filters?.endMonth
    ? `IT Managed Services Report - from ${filters.startMonth.label} ${filters.startYear.label} to ${filters.endMonth.label} ${filters.endYear.label}`
    : title;

  return (
    <ReportFilters
      onFetchClick={onFilter}
      onResetClick={onReset}
      title={activeTitle}
      loading={loading}
      disabled={!!filterError || !filters.contract.value}
      pdfExportAvailable={activeTitle.includes("Report")}
      exportDisabled={exportDisabled}
      onPDFExport={onPDFExport}
      isReport={isReport}
    >
      <Row>
        <Col md={4}>
          <DropdownSearch
            label="Contract *"
            name="contract"
            placeholder="Contract"
            onChange={onChangeFilters}
            value={filters.contract.value}
            data={contracts}
          />
        </Col>
        {multiple ? (
          <React.Fragment>
            <Col md={2}>
              <DropdownSearchSelect
                label
                errorMessage={
                  filterError?.field === "startMonth"
                    ? filterError?.message
                    : null
                }
                fieldLabel="Start Month"
                isSearchable={false}
                placeholder="Start Month"
                name="startMonth"
                onChange={onChangeFilters}
                value={filters.startMonth}
                data={filters.months}
              />
            </Col>
            <Col md={2}>
              <DropdownSearchSelect
                label
                errorMessage={
                  filterError?.field === "startYear"
                    ? filterError?.message
                    : null
                }
                fieldLabel="Start Year"
                isSearchable={false}
                placeholder="Start Year"
                name="startYear"
                onChange={onChangeFilters}
                value={filters.startYear}
                data={filters.years}
              />
            </Col>
            <Col md={2}>
              <DropdownSearchSelect
                label
                errorMessage={
                  filterError?.field === "endMonth"
                    ? filterError?.message
                    : null
                }
                fieldLabel="End Month"
                isSearchable={false}
                placeholder="End Month"
                name="endMonth"
                onChange={onChangeFilters}
                value={filters.endMonth}
                data={filters.months}
              />
            </Col>
            <Col md={2}>
              <DropdownSearchSelect
                label
                errorMessage={
                  filterError?.field === "endYear" ? filterError?.message : null
                }
                fieldLabel="End Year"
                isSearchable={false}
                placeholder="End Year"
                name="endYear"
                onChange={onChangeFilters}
                value={filters.endYear}
                data={filters.years}
              />
            </Col>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Col md={3}>
              <DropdownSearchSelect
                label
                errorMessage={
                  filterError?.field === "startMonth"
                    ? filterError?.message
                    : null
                }
                fieldLabel="Month"
                isSearchable={false}
                placeholder="Month"
                name="startMonth"
                onChange={onChangeFilters}
                value={filters.startMonth}
                data={filters.months}
              />
            </Col>
            <Col md={3}>
              <DropdownSearchSelect
                label
                errorMessage={
                  filterError?.field === "startYear"
                    ? filterError?.message
                    : null
                }
                fieldLabel="Year"
                isSearchable={false}
                placeholder="Year"
                name="startYear"
                onChange={onChangeFilters}
                value={filters.startYear}
                data={filters.years}
              />
            </Col>
          </React.Fragment>
        )}
      </Row>
      <Row>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            * Required Fields
          </label>
        </Col>
      </Row>
    </ReportFilters>
  );
};

Filters.propTypes = {
  onChangeFilters: PropTypes.func,
  filters: PropTypes.object,
  onReset: PropTypes.func,
  contracts: PropTypes.array,
  filterError: PropTypes.object,
  onFilter: PropTypes.func,
  multiple: PropTypes.bool,
  loading: PropTypes.bool,
  exportDisabled: PropTypes.bool,
  onPDFExport: PropTypes.func,
  isReport: PropTypes.bool,
  title: PropTypes.string
};

Filters.defaultProps = {
  onChangeFilters: () => null,
  filters: {},
  onReset: () => null,
  contracts: [],
  filterError: null,
  onFilter: () => null,
  multiple: false,
  title: ""
};

export default Filters;
